import { render } from "./Info.vue?vue&type=template&id=99ad8662"
import script from "./Info.vue?vue&type=script&lang=ts"
export * from "./Info.vue?vue&type=script&lang=ts"
script.render = render

export default script